module.exports = __webpack_public_path__ + "img/icon-24-ic-bin.2c9e5952.svg";